<template>
  <v-container>
    <v-card class="dt-border pad-10" flat>
      <v-container>
        <v-row class="pa-5 mb-5">
          <div>
            <h2>Stores</h2>
          </div>
          <v-spacer></v-spacer>
          <div>
            <store-modal v-if="can('can_manage_giftcards')" @reload = "reload"></store-modal>
          </div>
        </v-row>
        <dtunes-loader :loading="loading"></dtunes-loader>
        <store-table @reload = "reload" :details="details"></store-table>
        <dtunes-empty v-if="details.length == 0 && this.loading == false">
          <template v-slot:title>
            No Store Registered yet
          </template>
          <template v-slot:sub-title>
            Click on the create New Store button to create a Store
          </template>
        </dtunes-empty>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
// ================ IMPORT COMPONENTS ==============
import StoreModal from "../../components/store-modal.vue";
import StoreTable from "../../components/store-table.vue";
import DtunesLoader from "@/components/dtunes-loader.vue"
import DtunesEmpty from "@/components/dtunes-empty.vue"

// =============== IMPORT SERVICE TO LOAD STORES INTO COMPONENT ============== 
import { StoresService } from "@/services";

export default {
    components: {
      StoreModal,
      StoreTable,
      DtunesLoader,
      DtunesEmpty
    },
    data:() =>({
       details:[],
       loading:false
    }),
    mounted(){
      this.getStores();
    },
    methods: {
      async getStores(){
         try {
          this.loading= true
          const data = await StoresService.getStores();
          this.loading=false
          this.details = data;
          console.log(' this is the data: ', data);
        } catch (error) {
          this.loading=false
          console.log(error);
        }
      },
      async reload(){
        await this.getStores()
      }
    },
};
</script>